// extracted by mini-css-extract-plugin
export default {"hero":"Hero-module--hero--2tDM0","title":"Hero-module--title--2PIOG"};